import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDivisionUpd = async (credentials, data) => {
  const body = {
    service: "RNHDivisionUpd",
    params: {
      rnhDivisionId: data?.id,
      rnhDivisionCod: data?.cod,
      rnhDivisionNombre: data?.name,
      rnhDivisionDescripcion: data?.desc,
      rnhDivisionVersion: data?.version,
      rnhDepartamentoId: data?.dptoId || null,
      rnhDivisionAdmiteRotativos: data?.admiteRotativos || null,
      rnhDivisionAdmiteGuardias: data?.admiteGuardias || null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
